import React from 'react';

import { Tabs } from 'antd';

import { SettingsIssueType } from '../../components/Settings/SettingsIssueType';
import { SettingsMaintenanceType } from '../../components/Settings/SettingsMaintenanceType';
import { SettingsPaymentType } from '../../components/Settings/SettingsPaymentType';
import { SettingsSupplierType } from '../../components/Settings/SettingsSupplierType';
import { SettingsContextProvider } from '../../lib/providers/SettingsContextProvider';

export function SettingsCategories() {
    const items = [
        {
            key: 'chamados',
            label: 'Chamados',
            children: (
                <SettingsContextProvider>
                    {() => <SettingsIssueType />}
                </SettingsContextProvider>
            ),
        },
        {
            key: 'manutencoes',
            label: 'Manutenções',
            children: (
                <SettingsContextProvider>
                    {() => <SettingsMaintenanceType />}
                </SettingsContextProvider>
            ),
        },
        {
            key: 'pagamentos',
            label: 'Pagamentos',
            children: (
                <SettingsContextProvider>
                    {() => <SettingsPaymentType />}
                </SettingsContextProvider>
            ),
        },
        {
            key: 'fornecedores',
            label: 'Fornecedores',
            children: (
                <SettingsContextProvider>
                    {() => <SettingsSupplierType />}
                </SettingsContextProvider>
            ),
        },
    ];

    return (
        <Tabs defaultActiveKey="chamados" items={items} />
    );
}
